// extracted by mini-css-extract-plugin
export default {"tSwiper":"AnnoSwiper_tSwiper__FQ1ju","tSwiperSlide":"AnnoSwiper_tSwiperSlide__TDSdv"};